<div class="information-section">
  <div class="information-header">
    <h3 class="information-title">
      <span class="padding-right-3">
        <fa-icon icon="info" class="information-icon"></fa-icon>
      </span>
      <ng-content select="[slot='title']"></ng-content>
    </h3>
  </div>
  <div class="information-content">
    <ng-content></ng-content>
  </div>
</div>
